<!--begin::Main-->
<div class="d-flex flex-column flex-root">
	<!--begin::Login-->
	<div class="login login-3 wizard d-flex flex-column flex-lg-row flex-column-fluid">
		<!--begin::Aside-->
		<div class="login-aside d-flex flex-column flex-row-auto"
			style="box-shadow: inset -10px 0px 10px -10px rgba(0,0,0,0.5);">
			<!--begin::Aside Top-->

			<!--end::Aside Top-->
			<!--begin::Aside Bottom-->
			<div class="aside-img d-flex flex-row-fluid">
				<img src="assets/images/FPC.png" alt="FPC Image">
				<div class="caption">Veterinary Management</div>
			</div>
			<!--end::Aside Bottom-->

		</div>
		<div class="login-content flex-row-fluid d-flex flex-column p-10">
			<div class="d-flex flex-row-fluid flex-center">
				<!--begin::Login Sign in form-->
				<div class="login-form">
					<!--begin::Login Header-->
					<div class="login-content flex-row-fluid d-flex flex-column">
						<a href="#" class="login-logo pb-xl-15 pb-10">
							<span style="font-size:4rem;font-weight:600;color:#414e91 !important">Univet</span>
						</a>
					</div>
					<!--end::Login Header--> 
						<div class="pb-2 pb-lg-5">
							<div class="text-muted font-weight-bold font-size-h6" (click)="backToLogin()">
								<i class="las la-arrow-alt-circle-left"></i> Back to Login
							</div>
							<h3 class="font-weight-bolder text-dark font-size-h5 ">Register valid Email</h3> <br>  
						</div>

						<form [formGroup]="_registerForm">
								<div class="form-group">  
									<input [(ngModel)]="emailAddr" type="text" class="form-control h-auto py-4 px-8 font-size-h6" id="Email"
										formControlName="Email" placeholder="Email Address" required>
								</div> 
								<div class="form-group">
									<button type="button" class="btn btn-lg btn-block btn-success font-weight-bold font-size-h6" type="button"
										style="background-color:#182845" id="Register" (click)="register()">
										 &nbsp;Continue Registration
									</button>
								</div> 
						</form>
						

				</div>
			</div>

		</div>

	</div>
</div>
 
 
 <!-- <form [formGroup]="_registerForm">
	<label>Email address</label>
	<input [(ngModel)]="emailAddr" type="text" class="form-control" id="Email" formControlName="Email" required>
	 <button type="button" class="btn btn-main" id="Register" (click)="register()"><i class="fas fa-plus"></i>Register</button>
</form> -->

